import React from 'react';

const FreeLimitModal = ({ onClose, onUpgrade }) => {
    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.8)',
            zIndex: 2000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '20px',
            fontFamily: '"Noto Sans SC", "PingFang SC", "Microsoft YaHei", sans-serif',
        }}>
            <div style={{
                backgroundColor: '#1e293b',
                padding: 'clamp(20px, 5vw, 30px)',
                borderRadius: '24px',
                maxWidth: 'min(360px, calc(100vw - 40px))',
                width: '100%',
                textAlign: 'center',
                border: '1px solid rgba(255,255,255,0.1)',
                boxShadow: '0 20px 50px rgba(0,0,0,0.5)',
                boxSizing: 'border-box',
            }}>
                <div style={{ fontSize: '48px', marginBottom: '16px' }}>👀</div>

                <h2 style={{
                    fontSize: '22px',
                    color: '#f8fafc',
                    margin: '0 0 12px 0',
                    fontWeight: 'bold'
                }}>
                    Free Version Access
                </h2>

                <p style={{
                    color: '#94a3b8',
                    fontSize: '15px',
                    lineHeight: '1.6',
                    marginBottom: '24px'
                }}>
                    You are currently viewing the <strong style={{ color: '#ffffff' }}>top 150</strong> most frequent characters.
                    <br /><br />
                    Upgrade to Pro to unlock the full deck of <strong style={{ color: '#22c55e' }}>2,800+</strong> characters and master Chinese faster!
                </p>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                    <button
                        onClick={onUpgrade}
                        style={{
                            width: '100%',
                            padding: '14px',
                            borderRadius: '14px',
                            border: 'none',
                            background: 'linear-gradient(135deg, #ffd700, #f59e0b)',
                            color: '#713f12',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '8px',
                        }}
                    >
                        <span>👑</span> Check Plans
                    </button>

                    <button
                        onClick={onClose}
                        style={{
                            width: '100%',
                            padding: '14px',
                            borderRadius: '14px',
                            border: '1px solid rgba(255,255,255,0.1)',
                            background: 'rgba(255,255,255,0.05)',
                            color: '#94a3b8',
                            fontSize: '15px',
                            fontWeight: '500',
                            cursor: 'pointer',
                        }}
                    >
                        Got it, continue free
                    </button>
                </div>
            </div>
        </div>
    );
};

export default FreeLimitModal;
